<template>
  <v-dialog
    v-model="show"
    width="70%"
    overlay-color="darktext"
    overlay-opacity="0.6"
    content-class="content-create-template-dialog"
    :persistent="loading ? true : false"
    data-testid="dialog"
    scrollable
    ref="dialog"
  >
   
    <v-card elevation="0" color="card_background_grey">
       <AlertMessages
        v-if="alertValue"
        :alert-type="alertType"
        :alert-msg="alertMsg"
        @reset="alertValue = false"
      />
      <v-card-title class="white pb-0">
        <v-row no-gutters style="width:100%;">
          <v-col>
            <v-toolbar class="pa-0" dense flat color="white">
               <v-btn
                ref="back"
                text
                data-testid="back-button"
                class="rounded-xxl text-none pa-4"
                :ripple="false"
                style="z-index:1;"
                color="greytext"
                @click="closeDialog"
              >
                <v-icon class="ml-n1">mdi-chevron-left</v-icon>{{ $t('back') }}
              </v-btn>
              <v-spacer />
             
                <p class="text-h5 font-weight-bold text-center mx-auto mb-0 text-truncate">
                  {{ activityTitle }}
                </p>
              <v-spacer />
              <v-icon
                ref="cancel"
                data-testid="cancel-button"
                min-width="100"
                class="rounded-xxl text-none"
                style="z-index: 1"
                @click="closeDialog"
              >
                mdi-close
              </v-icon>
            </v-toolbar>
            <v-toolbar class="pa-0"
              dense
              flat
              color="white">
            </v-toolbar>
          </v-col>
        </v-row>
      </v-card-title>
      <v-divider class="elevation-2" dark />
      <v-card-text style="height: 70vh" ref="content" class="mt-1">
        <div class="d-inline-block fill-height">
            <v-navigation-drawer
              v-model="drawer"
              overlay-opacity="1"
              hide-overlay
              clipped
              color="background"
              fluid
              data-testid="navigation-drawer"
              style="z-index: 6"
              disable-resize-watcher
              stateless
              class="areaNavBar"
            >
              <div style="position: relative">
                <h3 class="pa-6">
                  {{ $t("activityPageFeedTitle") }}
                </h3>
              </div>
              <v-list-group
                v-for="listItem in list"
                :key="listItem.id"
                v-model="listItem.active"
                no-action
                router
                :class="{
                  'v-list-item--active':
                    activityDefaultItem.entity_id == listItem.entity_id,
                  'section': listItem.entity_type == 'section',
                }"
                color="anchor"
                class="menu_text pa-0"
                :ripple="false"
                :prepend-icon="
                  listItem.entity_type == 'section' ? '$expand' : ''
                "
                append-icon=""
                sub-group
                @click.prevent="listItem.entity_type == 'section'? '' : getPageContent(listItem)"
                data-testid="list-item"
              >
                <v-icon
                  v-if="listItem.entity_type == 'section'"
                  slot="prependIcon"
                  class="section-icon"
                >
                  {{ "$expand" }}
                </v-icon>
                <template v-slot:activator>
                  <v-list-item
                    data-testid="activity-page-item"
                    class="pa-0 activity-page-item"
                    :class="{
                      'v-list-item--active':
                        activityDefaultItem.entity_id == listItem.entity_id
                    }"
                  >
                    <v-row no-gutters>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-col
                            cols="10"
                            class="text-no-wrap text-truncate d-flex"
                            v-on="on"
                          >
                            <v-icon
                              v-if="
                                listItem.entity_type == 'activity_page' ||
                                listItem.entity_type == 'scorm'
                              "
                              class="v-list-item__icon"
                            >
                              mdi-text
                            </v-icon>
                            <v-icon
                              v-if="listItem.entity_type == 'quiz'"
                              class="v-list-item__icon"
                            >
                              mdi-chat-question-outline
                            </v-icon>
                            <v-icon
                              v-if="listItem.entity_type == 'checklist'"
                              class="v-list-item__icon"
                            >
                              mdi-order-bool-ascending-variant
                            </v-icon>
                            <v-icon
                              v-if="listItem.entity_type == 'survey'"
                              class="v-list-item__icon"
                            >
                             mdi-help-box-multiple-outline
                            </v-icon>
                                 <span
                              class="
                                title
                                text-truncate text-body-2
                                align-self-center
                              "
                            >
   
                              {{ listItem.title }}
                            </span>
                          </v-col>
                        </template>
                        <span>{{ listItem.title }}</span>
                      </v-tooltip>
                    </v-row>
                  </v-list-item>
                </template>
                <div v-if="listItem.entity_type == 'section'" class="areaInSection">
                <v-list-item
                  v-for="item in listItem.tasks"
                  :key="item.id"
                  data-testid="activity-page-item"
                  router
                  :class="{
                    'v-list-item--active':
                      activityDefaultItem.entity_id == item.entity_id
                  }"
                  color="background"
                  class="menu_text pa-0"
                  :ripple="false"
                  @click.prevent="
                    getPageContent(item)
                  "
                >
                  <v-row no-gutters class="custom-width">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-col
                          cols="10"
                          class="text-no-wrap text-truncate d-flex"
                          v-on="on"
                        >
                          <v-icon
                            v-if="
                              item.entity_type == 'activity_page' ||
                              item.entity_type == 'scorm'
                            "
                            class="v-list-item__icon"
                          >
                            mdi-text
                          </v-icon>
                          <v-icon
                            v-if="item.entity_type == 'quiz'"
                            class="v-list-item__icon"
                          >
                            mdi-chat-question-outline
                          </v-icon>
                          <v-icon
                            v-if="item.entity_type == 'checklist'"
                            class="v-list-item__icon"
                          >
                            mdi-order-bool-ascending-variant
                          </v-icon>
                          <v-icon
                            v-if="item.entity_type == 'survey'"
                            class="v-list-item__icon"
                          >
                           mdi-help-box-multiple-outline
                          </v-icon>
                          
                          <span
                            class="
                              title
                              text-truncate text-body-2
                              align-self-center
                            "
                          >
                            {{ item.title }}
                          </span>
                        </v-col>
                      </template>
                      <span>{{ item.title }}</span>
                    </v-tooltip>
                  </v-row>
                </v-list-item>
                </div>
              </v-list-group>
              <div
                v-if="error && error != ''"
                class="mt-15 px-4"
                data-testid="activity-pages-error"
              >
                <span class="d-block error--text">{{ error }}</span>
              </div>
            </v-navigation-drawer>
            </div>
            <div class="float-right fill-height d-inline-block preview-content activity-page-container" style="line-height: 1.5;">
            <v-card
              v-if="
                !loadingData &&
                activityDefaultItem.entity_type == 'activity_page'
              "
              ref="viewPage"
              elevation="0"
              class="mx-auto fill-height overflow-x-hidden"
              max-width="960px"
              
            >
              <runtime-template-compiler
                v-if="pageContent != null"
                :key="activityDefaultItem.id"
                :template="'<div>' + pageContent + '</div>'"
              />
              <EmptyPageActivity
                v-else
                max-width="960px"
                elevation="0"
                class="mx-auto"
                align="center"
                :page-title="$t('emptyActivityPageTitle')"
                :page-text="$t('emptyActivityPageText')"
                page-image="image4"
              />
            </v-card>
            <v-card
              v-if="
                !loadingData &&
                activityDefaultItem.entity_type == 'quiz'
              "
              data-testid="view-quiz"
              max-width="960px"
              elevation="0"
              class="mx-auto fill-height overflow-x-hidden"
              align="center"
              ref="viewPage"
            >
            <div v-if="!listQuestions.length">
              <EmptyPageActivity
                max-width="960px"
                elevation="0"
                class="mx-auto fill-height"
                align="center"
                :page-title="$t('emptyActivityQuizTitle')"
                :page-text="$t('emptyActivityQuizText')"
                page-image="image4"
              />
            </div>
            <div v-if="listQuestions.length > 0 && questionIndexDisplay == 0">
              <v-col align="center" class="pt-10 pt-md-16 mb-16">
                <img
                  class="mx-auto quiz-start-image-view"
                  :src="startUrl ? startUrl : require('../assets/quiz_start.png')"
                />
                <h4>{{ quizTitle }}</h4>
                <v-card-subtitle v-if="numberQuestions > 1" class="text-body-1">
                  {{ numberQuestions }} {{ $t("questionsInTotal") }}
                </v-card-subtitle>
                <v-card-subtitle v-else class="text-body-1">
                  {{ numberQuestions }} {{ $t("questionInTotal") }}
                </v-card-subtitle>
              </v-col>
              <v-btn
                data-testid="view-quiz-button"
                color="darktext"
                class="rounded-xxl text-none white--text px-4 my-2"
                @click="next()"
              >
                {{ $t("viewQuiz") }}
              </v-btn>
              </div>
            <div
              v-if="listQuestions.length > 0 && questionIndexDisplay > 0"
              max-width="960px"
              elevation="0"
              class="mx-auto fill-height"
              align="center"
            >
              <v-col>
                <v-card-text>
                  {{ $t("question") }} {{ currentQuestion.position }}/{{
                    numberQuestions
                  }}
                </v-card-text>
                <h5>{{ currentQuestion.question }}</h5>
                <div class="my-6">
                  <v-img
                    v-if="currentQuestion.imageDisplay != null"
                    width="100%"
                    max-width="400px"
                    :src="
                      currentQuestion.imageDisplay != null
                        ? currentQuestion.imageDisplay
                        : null
                    "
                  />
                </div>
                <div class="answer-section">
                  <v-card-text v-if="currentQuestion.typeAnswer != null">
                    <v-row
                      v-for="(answer, answerIndex) in currentQuestion.options"
                      :key="answerIndex"
                      align="center"
                      class="mb-3"
                    >
                      <v-text-field
                        v-if="currentQuestion.type == 1"
                        readonly
                        data-testid="answer-input"
                        solo
                        hide-details="auto"
                        class="rounded-xxl text-body-2 mx-5"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon
                            v-if="answer.isTrue"
                            data-testid="select-answer"
                            disabled
                            class="icon-des"
                            color="greytext"
                          >
                            mdi-radiobox-marked
                          </v-icon>
                          <v-icon
                            v-else
                            data-testid="select-answer"
                            class="icon-des"
                          >
                            mdi-radiobox-blank
                          </v-icon>
                          <p
                            data-testid="select-answer"
                            class="
                              pa-4
                              mb-0
                              font-weight-regular
                              align-middle
                              greytext--text
                            "
                          >
                            {{ answer.answer }}
                          </p>
                        </template>
                      </v-text-field>
                      <v-text-field
                        v-else
                        readonly
                        data-testid="answer-input"
                        solo
                        hide-details="auto"
                        class="rounded-xxl text-body-2 mx-5"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon
                            v-if="answer.isTrue"
                            data-testid="select-answer"
                            disabled
                            class="icon-des"
                            color="greytext"
                          >
                            mdi-checkbox-outline
                          </v-icon>
                          <v-icon
                            v-else
                            data-testid="select-answer"
                            class="icon-des"
                          >
                            mdi-checkbox-blank-outline
                          </v-icon>
                          <p
                            data-testid="select-answer"
                            class="pa-4 mb-0 font-weight-regular greytext--text"
                          >
                            {{ answer.answer }}
                          </p>
                        </template>
                      </v-text-field>
                    </v-row>
                  </v-card-text>
                  <v-card-text v-else>
                    <v-row align="center" justify="center">
                      <v-col
                        v-for="(answer, answerIndex) in currentQuestion.options"
                        :key="answerIndex"
                        align="center"
                        align-md="left"
                        cols="12"
                        md="4"
                        lg="4"
                      >
                        <v-card
                          rounded="xxl"
                          width="250px"
                          color="greyactivitybackground"
                        >
                          <v-row
                            v-if="currentQuestion.type == 1"
                            align="center"
                            justify="center"
                            class="pa-3 row-pointer"
                            data-testid="answer-input"
                          >
                            <v-icon
                              v-if="answer.isTrue"
                              data-testid="select-answer"
                              disabled
                              class="icon-des"
                              color="greytext"
                            >
                              mdi-radiobox-marked
                            </v-icon>
                            <v-icon
                              v-else
                              data-testid="select-answer"
                              class="icon-des"
                            >
                              mdi-radiobox-blank
                            </v-icon>
                            <v-img
                              data-testid="select-answer"
                              class="rounded-lg text-center align-center mx-3"
                              width="100%"
                              height="106"
                              :src="
                                answer.imageDisplay != null
                                  ? answer.imageDisplay
                                  : null
                              "
                            />
                          </v-row>
                          <v-row
                            v-else
                            align="center"
                            justify="center"
                            class="pa-3 row-pointer"
                            data-testid="answer-input"
                          >
                            <v-icon
                              v-if="answer.isTrue"
                              data-testid="select-answer"
                              disabled
                              class="icon-des"
                              color="greytext"
                            >
                              mdi-checkbox-outline
                            </v-icon>
                            <v-icon
                              v-else
                              data-testid="select-answer"
                              class="icon-des"
                            >
                              mdi-checkbox-blank-outline
                            </v-icon>
                            <v-img
                              data-testid="select-answer"
                              class="rounded-lg text-center align-center mx-3"
                              width="100%"
                              height="106"
                              :src="
                                answer.imageDisplay != null
                                  ? answer.imageDisplay
                                  : null
                              "
                            />
                          </v-row>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </div>
                <v-row>
                  <v-col fixed align="center">
                    <v-btn
                      v-if="questionIndexDisplay > 0"
                      data-testid="previous-button"
                      outlined
                      elevation="0"
                      class="rounded-xxl text-none mx-4 px-4 my-4"
                      @click="prev()"
                    >
                      {{ $t("previous") }}
                    </v-btn>

                    <v-btn
                      v-if="
                        questionIndexDisplay != 0 &&
                        questionIndexDisplay <= numberQuestions - 1
                      "
                      data-testid="next-button"
                      color="darktext"
                      class="rounded-xxl text-none white--text px-4 my-4 mx-4"
                      @click="next()"
                    >
                      {{ $t("next") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </div>
            </v-card>
            <v-card
              v-if="
                !loadingData && activityDefaultItem.entity_type == 'checklist'"
              ref="viewPage"
              max-width="960px"
              elevation="0"
              class="mx-auto fill-height view-checklist overflow-x-hidden"
            >
            <div v-if="hasContentChecklist">
              <div v-if="imageUrl != null" data-testid="checklist-image">
                <v-img :src="imageUrl" width="100%" max-height="330px" />
              </div>
              <!-- eslint-disable vue/no-v-html -->
              <div
                v-if="description != null"
                class="px-8 py-4"
                data-testid="checklist-description"
                v-html="description"
              />
              <div
                v-if="checklist.length > 0"
                data-testid="checklist-items"
                class="px-8 py-4"
              >
                <div
                  v-for="(element, index) in checklist"
                  :key="index"
                  class="content-block"
                  data-testid="checklist-item"
                >
                  <!-- eslint-disable vue/no-v-html -->
                  <v-divider class="mx-md-15" />
                  <div class="px-md-15 py-5">
                    <v-checkbox
                      v-model="element.attributes.checked"
                      :off-icon="'mdi-square-rounded-outline'"
                      hide-details
                      class="shrink mt-0 checklist-off-icon"
                      color="success"
                      data-testid="checklist-item-checkbox"
                    >
                      <template v-slot:label>
                        <p
                          class="font-weight-bold ml-2 mb-0 no-break"
                          :class="
                            element.attributes.checked
                              ? 'text-decoration-line-through greytext--text'
                              : ''
                          "
                        >
                          {{ element.attributes.title }}
                        </p>
                      </template>
                    </v-checkbox>
                    <div class="ml-10" v-html="element.attributes.content" />
                  </div>
                </div>
                </div>
              </div>
              <div v-else>
              <EmptyPageActivity
                  max-width="960px"
                  elevation="0"
                  class="mx-auto fill-height"
                  align="center"
                  :page-title="$t('emptyActivityChecklistTitle')"
                  :page-text="$t('emptyActivityChecklistText')"
                  page-image="image4"
                />
              </div>
            </v-card>
            <v-card
              v-if="!loadingData && activityDefaultItem.entity_type == 'scorm'"
                  max-width="960px"
                  elevation="0"
                  class="mx-auto fill-height overflow-x-hidden"
                  data-testid="view-scorm"
                >
                  <div v-if="scormPackage" class="scorm-player mt-5">
                    <iframe :src="scormPackage" style="border: none" />
                  </div>
                  <EmptyPageActivity
                    v-else
                    max-width="960px"
                    elevation="0"
                    class="mx-auto fill-height"
                    align="center"
                    :page-title="$t('emptyActivityScormTitle')"
                    :page-text="$t('emptyActivityScormText')"
                    page-image="image4"
                />
              </v-card>
              <v-card
                v-if="!loadingData && activityDefaultItem.entity_type == 'survey'"
                  max-width="960px"
                  elevation="0"
                  class="mx-auto fill-height overflow-x-hidden"
                  data-testid="view-survey"
                  :color="surveys.length > 0 ? 'card_background_grey' : 'white'"
                >
                  <div v-if="surveys.length > 0" style="height: calc(100% - 70px);">
                    <v-carousel v-model="model" :vertical="true" :show-arrows="false" hide-delimiters
                        height="100%" transition="scroll-y-transition"
                        reverse-transition="scroll-y-transition" class="survey-carousel rounded-xxl" light
                      >
                        <v-carousel-item v-for="(selectedQuestion, i) in allQuestions" :key="i"
                          :style="`background-color:` + selectedQuestion.bg_color">
                          <v-container v-if="selectedQuestion.type == 'start'" data-testid="start-screen" ref="start"
                            class="list-group-item fill-height pa-0"
                          >
                            <v-row justify="center" align="center" no-gutters>
                              <v-col cols="12">
                                <StartScreen :anonymous="isAnonymous" :title="startTitle" :description="startDescription"
                                  :imageDisplay="startImageDisplay" :image="startImage"
                                  :color="startColor == null ? '#FFFFFF' : startColor" :preview="true"
                                />
                              </v-col>
                            </v-row>
                          </v-container>
                          <v-container v-if="selectedQuestion.type != 'start' && selectedQuestion.type != 'end'"
                            class="list-group-item fill-height pa-0"
                          >
                            <v-row justify="center" align="center" no-gutters>
                              <v-col cols="12">
                                <div class="content-block rounded-xxl pa-12">
                                  <v-row align="center" no-gutters class="text-center">
                                    <v-col cols="12"
                                      v-if="selectedQuestion.question && strip(selectedQuestion.question).trim() != ''">
                                      <p class="text-subtitle-1 no-break" v-html="selectedQuestion.question"></p>
                                    </v-col>
                                    <v-col cols="12" class="mt-3"
                                      v-if="selectedQuestion.description && strip(selectedQuestion.description).trim() != ''">
                                      <p class="text-subtitle-2 font-weight-regular greytext--text no-break"
                                        v-html="selectedQuestion.description"></p>
                                    </v-col>
                                  </v-row>
                                  <v-row v-if="selectedQuestion.type == 1" align="center" justify="center"
                                    data-testid="survey-1" class="mt-5" no-gutters>
                                    <v-col cols="12" sm="12" lg="7">
                                      <MultipleChoiceTextQuestionTextAnswer :question="selectedQuestion"/>
                                    </v-col>
                                  </v-row>
                                  <v-row v-if="selectedQuestion.type == 2" align="center" justify="center"
                                    data-testid="survey-2" class="mt-5" no-gutters>
                                    <v-col cols="12">
                                      <MultipleChoiceTextQuestionTextImageAnswer :question="selectedQuestion" />
                                    </v-col>
                                  </v-row>
                                  <v-row v-if="selectedQuestion.type == 3" align="center" justify="center"
                                    data-testid="survey-2" class="mt-5" no-gutters>
                                    <v-col cols="12" sm="12" lg="7">
                                      <MultipleChoiceTextImageQuestionTextAnswer :question="selectedQuestion" />
                                    </v-col>
                                  </v-row>
                                  <v-row v-else-if="selectedQuestion.type == 4" align="center" justify="center"
                                    data-testid="survey-4" class="mt-5" no-gutters>
                                    <v-col cols="12" sm="12" lg="7">
                                      <OpenText :question="selectedQuestion" />
                                    </v-col>
                                  </v-row>
                                  <v-row v-else-if="selectedQuestion.type == 5" align="center" justify="center"
                                    data-testid="survey-5" class="mt-5" no-gutters>
                                    <v-col cols="12" sm="12" lg="7">
                                      <OpenTextAttachment :question="selectedQuestion" />
                                    </v-col>
                                  </v-row>
                                  <v-row v-else-if="selectedQuestion.type == 6" align="center" justify="center"
                                    data-testid="survey-6" class="mt-5" no-gutters>
                                    <v-col cols="12">
                                      <RatingStars :question="selectedQuestion" />
                                    </v-col>
                                  </v-row>
                                  <v-row v-else-if="selectedQuestion.type == 7" align="center" justify="center"
                                    data-testid="survey-7" class="mt-5" no-gutters>
                                    <v-col cols="12">
                                      <RatingNumbers :question="selectedQuestion" />
                                    </v-col>
                                  </v-row>
                                  <v-row v-else-if="selectedQuestion.type == 8" align="center" justify="center"
                                    data-testid="survey-8" class="mt-5" no-gutters>
                                    <v-col cols="12">
                                      <RatingNumbersComment :question="selectedQuestion" :preview="true"/>
                                    </v-col>
                                  </v-row>
                                </div>
                              </v-col>
                            </v-row>
                          </v-container>
                          <v-container v-if="selectedQuestion.type == 'end'" data-testid="end-screen" ref="end"
                            class="list-group-item fill-height pa-0"
                          >
                            <v-row justify="center" align="center" no-gutters>
                              <v-col cols="12">
                                <EndScreen :anonymous="isAnonymous" :title="endTitle" :description="endDescription"
                                  :imageDisplay="endImageDisplay" :image="endImage"
                                  :color="endColor == null ? '#FFFFFF' : endColor" :preview="true"
                                />
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-carousel-item>
                      </v-carousel>
                  </div>
                  <v-footer v-if="surveys.length > 0" class="white pa-0" color="card_background_grey">
                    <v-col fixed align="center" class="pa-0">
                      <v-btn v-if="model != '0'" data-testid="previous-button" outlined elevation="0"
                        class="rounded-xxl text-none mx-4 px-4 my-4" @click="questionIndex--, model--">
                        {{ $t('previous') }}
                      </v-btn>

                      <v-btn v-if="model != surveys.length + 1" data-testid="next-button" color="darktext"
                        class="rounded-xxl text-none white--text px-4 my-4 mx-4" @click="questionIndex++, model++">
                        {{ $t('next') }}
                      </v-btn>
                    </v-col>
                  </v-footer>
                  <EmptyPageActivity
                    v-else
                    max-width="960px"
                    elevation="0"
                    class="mx-auto fill-height"
                    align="center"
                    :page-title="$t('emptyActivitySurveyTitle')"
                    :page-text="$t('emptyActivitySurveyText')"
                    page-image="image4"
                />
                </v-card>
        </div>
      </v-card-text>
    </v-card>

    <ConfirmationDialog
      v-if="dialogVisiblePreviewActivity"
      ref="confirmationDialogPreviewActivity"
      :visible="dialogVisiblePreviewActivity"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      data-testid="confirmation-dialog-preview-activity"
      @close="dialogVisiblePreviewActivity = false"
    />
  </v-dialog>
</template>
<script>
import i18n from "../plugins/i18n";
import {
  getActivityPages,
  getActivityPage,
  changeImageInActivityPage,
  changeDocumentInActivityPage,
  getActivityQuiz,
  getQuizQuestions,
  getQuestion,
  getImageURLsInActivityQuiz,
  getActivityChecklist,
  getChecklistItems,
  changeImageInChecklist,
  getActivityScorm,
  getActivitySurvey,
  getImageURLsInActivitySurvey,
  getSurveyQuestions
} from "../api/activityApi";
import ConfirmationDialog from "./ConfirmationDialog";
import AlertMessages from "./AlertMessages";
import { RuntimeTemplateCompiler } from "vue-runtime-template-compiler";
import { repeatedMethodsMixin } from "../mixins/repeatedMethodsMixin";
import EmptyPageActivity from "./EmptyPageActivity";
import MultipleChoiceTextQuestionTextAnswer from './editor_components/survey/view/MultipleChoiceTextQuestionTextAnswer.vue'
import MultipleChoiceTextQuestionTextImageAnswer from './editor_components/survey/view/MultipleChoiceTextQuestionTextImageAnswer.vue'
import MultipleChoiceTextImageQuestionTextAnswer from './editor_components/survey/view/MultipleChoiceTextImageQuestionTextAnswer.vue'
import OpenText from './editor_components/survey/view/OpenText.vue'
import OpenTextAttachment from './editor_components/survey/view/OpenTextAttachment.vue'
import RatingNumbers from './editor_components/survey/view/RatingNumbers.vue'
import RatingNumbersComment from './editor_components/survey/view/RatingNumbersComment.vue'
import RatingStars from './editor_components/survey/view/RatingStars.vue'
import StartScreen from './editor_components/survey/view/StartScreen'
import EndScreen from './editor_components/survey/view/EndScreen.vue';

export default {
  components: {
    ConfirmationDialog,
    AlertMessages,
    RuntimeTemplateCompiler,
    EmptyPageActivity,
    MultipleChoiceTextQuestionTextAnswer,
    MultipleChoiceTextQuestionTextImageAnswer,
    MultipleChoiceTextImageQuestionTextAnswer,
    OpenText,
    OpenTextAttachment,
    RatingNumbers,
    RatingNumbersComment,
    RatingStars,
    StartScreen,
    EndScreen,
  },
  mixins: [repeatedMethodsMixin],
  props: {
    visible: Boolean,
    activityId: {
      type: String,
      default: "",
    },
    activityTitle: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      valid: true,
      alertMsg: "",
      alertType: "",
      alertValue: false,
      spaceId: window.$cookies.get("space_id"),
      loadingData: false,
      loading: false,
      confirmationDialogTitle: "",
      confirmationDialogText: "",
      confirmationDialogCancelBtn: "",
      confirmationDialogSubmitBtn: "",
      dialogVisiblePreviewActivity: false,
      list: [],
      error: "",
      drawer: true,
      activityDefaultItem: {},
      pageContent: null,
      quizTitle: "",
      numberQuestions: "",
      questionIndex: 0,
      questionIndexDisplay: 0,
      currentQuestion: {},
      listQuestions: [],
      image: null,
      imageUrl: null,
      description: null,
      checklist: [],
      hasContentChecklist: false,
      scormPackage: null,
      surveys: [],
      isAnonymous: false,
      startTitle: null,
      startDescription: null,
      endTitle: null,
      endDescription: null,
      startImage: null,
      startImageDisplay: null,
      endImage: null,
      endImageDisplay: null,
      startColor: null,
      endColor: null,
      model: 0,
      allQuestions: [],
      startUrl: null,
      startPath: null
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      }
    },
  },
  async created() {
    this.loadingData = true;
    await this.getActivityPages();
    this.loadingData = false;
  },

  methods: {
    async getActivityPages() {
      try {
        const response = await getActivityPages(this.activityId, this.spaceId);
        if (response.status == 200) {
          this.list = [];
          this.pages = response.data.data;

          if (   this.pages.filter(
              (page) =>
                page.attributes.entity_type != "section"
            ).length > 0
          ) {
            let defaultItem = this.pages.filter(
              (page) =>
                page.attributes.entity_type != "section"
            )[0];
            this.activityDefaultItem = {
              id: defaultItem.id,
              title: defaultItem.attributes.title,
              entity_type: defaultItem.attributes.entity_type,
              entity_id: defaultItem.attributes.entity_id,
              position: defaultItem.attributes.position,
              section_id: defaultItem.attributes.section_id,
            };
          }

          for (let i = 0; i < this.pages.length; i++) {
            if (this.pages[i].attributes.section_id == null) {
              this.list.push({
                id: this.pages[i].id,
                title: this.pages[i].attributes.title,
                entity_type: this.pages[i].attributes.entity_type,
                entity_id: this.pages[i].attributes.entity_id,
                position: this.pages[i].attributes.position,
                section_id: this.pages[i].attributes.section_id,
                tasks: [],
                active: false
              });
            } else {
              let nestedSection = this.list.find(
                ({ entity_id }) =>
                  entity_id === this.pages[i].attributes.section_id
              );
              nestedSection.tasks.push({
                id: this.pages[i].id,
                title: this.pages[i].attributes.title,
                entity_type: this.pages[i].attributes.entity_type,
                entity_id: this.pages[i].attributes.entity_id,
                position: this.pages[i].attributes.position,
                section_id: this.pages[i].attributes.section_id,
                tasks: [],
                active: false
              });
            }
          }

          await this.getPageContent(this.activityDefaultItem);
        }
      } catch (e) {
        if (e.response) {
          this.error = i18n.t("dataNotRetrievedError");
        }
      }
    },
    async getPageContent(activityDefaultItem) {
      this.loadingData = true
      this.$refs.content.scrollTop = 0

      this.pageContent = null

      this.questionIndex= 0
      this.questionIndexDisplay= 0
      this.currentQuestion= {}
      this.listQuestions= []

      this.activityDefaultItem = activityDefaultItem;
      if (activityDefaultItem.entity_type == "activity_page") {
        await this.getActivityPage(activityDefaultItem.entity_id);
      } else if (activityDefaultItem.entity_type == "scorm") {
        await this.getActivityScorm(activityDefaultItem.entity_id);
      } else if (activityDefaultItem.entity_type == "quiz") {
        await this.getActivityQuiz(activityDefaultItem.entity_id);
      } else if (activityDefaultItem.entity_type == "checklist"){
        await this.getActivityChecklist(activityDefaultItem.entity_id);
      }else {
        await this.getActivitySurvey(activityDefaultItem.entity_id);
      }
      this.loadingData = false
    },

    async getActivityPage(id) {
      const response_page = await getActivityPage(id, this.spaceId);
      if (response_page && response_page.status == 200) {
        this.pageContent = response_page.data.data.attributes.content;
        //create element just for manipulating files
        var element = document.createElement("div");
        element.insertAdjacentHTML("beforeend", this.pageContent);
        if (element.querySelectorAll("[path]").length > 0) {
          await this.changeTemporaryURLs(
            element.querySelectorAll("[path]"),
            element,
            id
          );
        }
        if (element.querySelectorAll("[pathDoc]").length > 0) {
          await this.changeTemporaryURLsDoc(
            element.querySelectorAll("[pathDoc]"),
            element,
            id
          );
        }
        if (element.querySelectorAll("[pathAudio]").length > 0) {
          await this.changeTemporaryURLsAudio(
            element.querySelectorAll("[pathAudio]"),
            element,
            id
          );
        }
      }
    },

    async changeTemporaryURLs(nodes, element, id) {
      var listNodes = [];
      for (var i = 0; i < nodes.length; i++) {
        if (listNodes.indexOf(nodes[i].attributes.path.nodeValue) === -1) {
          listNodes.push(nodes[i].attributes.path.nodeValue);
        }
      }
      try {
        let data = {
          data: {
            type: "activity-pages",
            id: id,
            attributes: {
              paths: listNodes,
              space_id: this.spaceId,
            },
          },
        };
        const response = await changeImageInActivityPage(id, data, this.spaceId);
       
         Object.keys(response.data.meta.files).forEach(function(key) {
              //find and change in html
              element.querySelectorAll('[path="' + key +'"]').forEach(function(item){
                  item.attributes.src.nodeValue=response.data.meta.files[key]
              })
        });

        this.pageContent = element.innerHTML;
      } catch (e) {
        this.alertValue = true;
        this.alertType = "error";
        this.alertMsg = i18n.t("serverError");
      }
    },
    async changeTemporaryURLsDoc(nodes, element, id) {
      var listNodes = [];
      for (var i = 0; i < nodes.length; i++) {
        if (listNodes.indexOf(nodes[i].attributes.pathDoc.nodeValue) === -1) {
          listNodes.push(nodes[i].attributes.pathDoc.nodeValue);
        }
      }
      try {
        let data = {
          data: {
            type: "activity-pages",
            id: id,
            attributes: {
              paths: listNodes.filter((x, i, a) => a.indexOf(x) == i),
              space_id: this.spaceId,
            },
          },
        };
        const response = await changeDocumentInActivityPage(id, data, this.spaceId);
        Object.keys(response.data.meta.files).forEach(function (key) {
          //find and change in html
          element
            .querySelectorAll('[pathDoc="' + key + '"]')
            .forEach(function (item) {
              item.attributes.href.nodeValue =
                response.data.meta.files[key].url;
            });
        });

        this.pageContent = element.innerHTML;
      } catch (e) {
        this.alertValue = true;
        this.alertType = "error";
        this.alertMsg = i18n.t("serverError");
      }
    },
    async changeTemporaryURLsAudio(nodes, element, id) {
      var listNodes = [];
      for (var i = 0; i < nodes.length; i++) {
        if (listNodes.indexOf(nodes[i].attributes.pathAudio.nodeValue) === -1) {
          listNodes.push(nodes[i].attributes.pathAudio.nodeValue);
        }
      }
      try {
        let data = {
          data: {
            type: "activity-pages",
            id: id,
            attributes: {
              paths: listNodes.filter((x, i, a) => a.indexOf(x) == i),
              space_id: this.spaceId,
            },
          },
        };
        const response = await changeDocumentInActivityPage(id, data, this.spaceId);
        Object.keys(response.data.meta.files).forEach(function (key) {
          //find and change in html
          element
            .querySelectorAll('[pathAudio="' + key + '"]')
            .forEach(function (item) {
              item.attributes.file.nodeValue =
                response.data.meta.files[key].url;
            });
        });
        this.pageContent = element.innerHTML;
      } catch (e) {
        this.alertValue = true;
        this.alertType = "error";
        this.alertMsg = i18n.t("serverError");
      }
    },

    async getActivityQuiz(id) {
      const response_page = await getActivityQuiz(id, this.spaceId);
      if (response_page && response_page.status == 200) {
        this.quizTitle = response_page.data.data.attributes.title;
        this.startPath = response_page.data.data.attributes.start_image
        this.startUrl = this.startPath ? await this.changeImageURLs(this.startPath, 'quiz') : null
        await this.getActivityQuizQuestions(id, this.spaceId);
      }
    },

    async getActivityQuizQuestions(id) {
      this.listQuestions = [];
      this.questionIndex = 0;
      this.questionIndexDisplay = 0;
      this.result = null;
      try {
        const response = await getQuizQuestions(id);
        if (response.status == 200) {
          this.numberQuestions = response.data.meta.questions.length;
          var questions = response.data.meta.questions;
          for (var i = 0; i < questions.length; i++) {
            this.listQuestions.push(questions[i]);
          }
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 404) {
            this.$router.push({ name: "PageNotFound" });
          } else {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("dataNotRetrievedError");
          }
        }
      }
    },

    prev() {
      if (this.questionIndex == this.numberQuestions) {
        this.questionIndexDisplay = this.questionIndex - 1;
        this.questionIndex--;
      } else {
        this.questionIndexDisplay--;
      }

      if (this.questionIndex == 0) {
        this.questionIndex = 1;
      }
      this.questionIndex--;

      if (this.questionIndex == this.questionIndexDisplay) {
        if (this.questionIndex == 0) {
          this.questionIndex = 1;
        }
        this.questionIndex--;
      }

      this.getQuestion(this.listQuestions[this.questionIndex]);
    },
    next() {
      if (this.questionIndex < this.questionIndexDisplay) {
        this.questionIndex++;
      }

      this.getQuestion(this.listQuestions[this.questionIndex]);

      if (this.questionIndex <= this.numberQuestions - 1) {
        this.questionIndex++;
      }

      this.questionIndexDisplay++;
    },

    async getQuestion(index) {
      try {
        const response_question = await getQuestion(index, this.spaceId);
        if (response_question.status == 200) {
          var responseQuestionImageURL = await this.changeImageURLs(
            response_question.data.data.attributes.image, 'quiz'
          );
          var options = [];
          for (const answer of response_question.data.data.attributes.options) {
            var responseAnswerImageURL = await this.changeImageURLs(
              answer.image, 'quiz'
            );

            options.push({
              aid: answer.aid,
              answer: answer.answer,
              image: answer.image,
              imageDisplay: responseAnswerImageURL,
              isTrue: answer.isTrue,
            });
          }
          this.currentQuestion = {
            qid: response_question.data.data.id,
            id: response_question.data.data.id,
            question: response_question.data.data.attributes.question,
            image: response_question.data.data.attributes.image,
            imageDisplay: responseQuestionImageURL,
            type: response_question.data.data.attributes.type,
            typeAnswer: options[0].answer,
            options: options,
            position: response_question.data.data.attributes.position,
          };
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true;
          if (e.response.status == 422) {
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          } else if (e.response.status == 403) {
            ///this.$router.push({name: 'PageAccessDenied'})
          } else if (e.response.status == 404) {
            this.$router.push({ name: "PageNotFound" });
          } else {
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }
    },

    async changeImageURLs(value, type) {
      var imagesToCheck = [];
      if(type == 'quiz'){
        if (value != null) {
          imagesToCheck = [value];

          let dataImage = {
            data: {
              type: "quizzes",
              id: this.activityDefaultItem.entity_id,
              attributes: {
                paths: imagesToCheck,
                space_id: this.spaceId,
              },
            },
          };

          const responseImageQuestion = await getImageURLsInActivityQuiz(
            this.activityDefaultItem.entity_id,
            dataImage,
            this.spaceId
          );
          return responseImageQuestion.data.meta.files[value];
        } else {
          return null;
        }
      }else {
        if (value != null) {
        imagesToCheck = [value]

        let dataImage = {
          data: {
            type: "surveys",
            id: this.activityDefaultItem.entity_id,
            attributes: {
              paths: imagesToCheck,
              space_id: this.spaceId
            }
          }
        };

        const responseImageQuestion = await getImageURLsInActivitySurvey(this.activityDefaultItem.entity_id, dataImage, this.spaceId)
        return responseImageQuestion.data.meta.files[value]
        } else {
          return null
        }
      }
        
    },

    async getActivityChecklist(id) {
      const response_page = await getActivityChecklist(id, this.spaceId);
      if (response_page && response_page.status == 200) {
        const response_checkitems = await getChecklistItems(id, this.spaceId);
        if (response_checkitems.status == 200) {
          this.image = response_page.data.data.attributes.published_image ? response_page.data.data.attributes.published_image : response_page.data.data.attributes.image
          this.imageUrl = response_page.data.data.attributes.published_image_url ? response_page.data.data.attributes.published_image_url : response_page.data.data.attributes.image_url
          this.description = response_page.data.data.attributes.published_description ? response_page.data.data.attributes.published_description : response_page.data.data.attributes.description


          this.checklist = response_checkitems.data.data;
          this.hasContentChecklist = false

          if (
            this.image != null ||
            this.description != null ||
            this.checklist.length > 0
          ) {
            this.hasContentChecklist = true
          }

          if (this.checklist.length > 0) {
            await this.changeTemporaryURLsChecklist(id);
          }
        }
      }
    },

    async changeTemporaryURLsChecklist(id) {
      for (var index = 0; index < this.checklist.length; index++) {
        var element = document.createElement("div");
        element.insertAdjacentHTML(
          "beforeend",
          this.checklist[index].attributes.content
        );
        if (element.querySelectorAll("[path]").length > 0) {
          const key = element.querySelector("[path]").attributes.path.nodeValue;
          let data = {
            data: {
              type: "checklists",
              id: id,
              attributes: {
                paths: [
                  element.querySelector("[path]").attributes.path.nodeValue,
                ],
                space_id: this.spaceId,
              },
            },
          };
          const response = await changeImageInChecklist(id, data, this.spaceId);
          //find and change in html
          element.querySelector(
            '[path="' + key + '"]'
          ).attributes.src.nodeValue = response.data.meta.files[key];
          this.checklist[index].attributes.content = element.innerHTML.replace(
            /&amp;/g,
            "&"
          );
        }
      }
    },

    async getActivityScorm(id) {
      const response_scorm = await getActivityScorm(id, this.spaceId);
      if (response_scorm && response_scorm.status == 200) {
        if (response_scorm.data.data.attributes.url != null) {
          this.scormPackage =
            process.env.VUE_APP_API_IFRAME_URL +
            "/activity/" +
            this.activityId +
            "/scorm/" +
            id +
            "/" +
            window.$cookies.get("token");
        } else {
          this.scormPackage = null;
        }
      }
    },

    async getActivitySurvey(id) {     
      this.model = 0
      const response_survey = await getActivitySurvey(id, this.spaceId);
      if (response_survey && response_survey.status == 200) {
        this.isAnonymous = response_survey.data.data.attributes.is_anonymous
        this.startTitle = response_survey.data.data.attributes.start_title
        this.startDescription = response_survey.data.data.attributes.start_description
        this.startImage = response_survey.data.data.attributes.start_image
        this.startImageDisplay = response_survey.data.data.attributes.start_image_url
        this.startColor = response_survey.data.data.attributes.start_bg_color
        this.endTitle = response_survey.data.data.attributes.end_title
        this.endDescription = response_survey.data.data.attributes.end_description
        this.endImage = response_survey.data.data.attributes.end_image
        this.endImageDisplay = response_survey.data.data.attributes.end_image_url
        this.endColor = response_survey.data.data.attributes.end_bg_color
        await this.getSurveyQuestions(id);
      }
    },

    async getSurveyQuestions(id) {
      try {
        this.surveys = []
        this.allQuestions = []
        const response = await getSurveyQuestions(id, this.spaceId)
        if (response) {
          if (response.status == 200) {
            for (const value of response.data.data) {
              if (value.attributes.type == 1 || value.attributes.type == 2 || value.attributes.type == 3) {
                var responseQuestionImageURL = await this.changeImageURLs(value.attributes.image, 'survey')
                var options = []
                for (const answer of value.attributes.options) {
                  var responseAnswerImageURL = await this.changeImageURLs(answer.image, 'survey')
                  options.push(
                    {
                      aid: answer.aid,
                      option: answer.option,
                      image: answer.image,
                      imageDisplay: responseAnswerImageURL,
                    }
                  )
                }

                this.surveys.push({
                  qid: value.id,
                  id: value.id,
                  question: value.attributes.question,
                  description: value.attributes.description,
                  image: value.attributes.image,
                  imageDisplay: responseQuestionImageURL,
                  bg_color: value.attributes.bg_color,
                  allowed_options: value.attributes.allowed_options,
                  type: value.attributes.type,
                  options: options
                });

              } else if (value.attributes.type == 4 || value.attributes.type == 5) {
                this.surveys.push({
                  qid: value.id,
                  id: value.id,
                  question: value.attributes.question,
                  description: value.attributes.description,
                  image: null,
                  imageDisplay: null,
                  bg_color: value.attributes.bg_color,
                  type: value.attributes.type,
                });

              } else {
                this.surveys.push({
                  qid: value.id,
                  id: value.id,
                  question: value.attributes.question,
                  description: value.attributes.description,
                  image: null,
                  imageDisplay: null,
                  bg_color: value.attributes.bg_color,
                  allowed_options: value.attributes.allowed_options,
                  type: value.attributes.type,
                });
              }

            }
            //created new array that will contains all question, start screen and endscreen. For carousel scroll effect
            this.allQuestions = JSON.parse(JSON.stringify(this.surveys))
            this.allQuestions.unshift({ qid: 'start', type: 'start', bg_color: this.startColor == null ? '#FFFFFF' : this.startColor })
            this.allQuestions.push({ qid: 'end', type: 'end', bg_color: this.endColor == null ? '#FFFFFF' : this.endColor })
          }
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true
          this.alertType = 'error'
          this.alertMsg = i18n.t('serverError')
        }
      }
    },

    closeDialog() {
      if (!this.loading) {
        this.$emit("close");
      }
    },
  },
};
</script>
